import React, { useState } from "react";
import { facilityData } from './facilityData';
import { FacilityAccordion } from './FacilityAccordion';
import { Box } from "@mui/material";
import { LabelIcons } from "../newDashboard/Svg/labelIcons";

interface MainviewProps {
  selectedFacility: any;
  floorData: any;
  handleGetSummaryData: any,
}

const Dashboard: React.FC<MainviewProps> = ({ selectedFacility, floorData, handleGetSummaryData }) => {
  const [expandedFacility, setExpandedFacility] = useState<string | false>('panel0');
  const [expandedUnit, setExpandedUnit] = useState<string | false>('panel0');
  console.log("Dashboard ::", floorData);

  const facilities = Array.isArray(floorData) ? floorData.filter((item: any) => !item.isUnit) : [];
  const units = Array.isArray(floorData) ? floorData.filter((item: any) => item.isUnit) : [];

  const handleChangeFacility = (panel: string) => {
    setExpandedFacility(expandedFacility === panel ? false : panel);
  };

  const handleChangeUnit = (panel: string) => {
    setExpandedUnit(expandedUnit === panel ? false : panel);
  };



  return (
    <Box sx={{ marginBottom: "20px", pb: 2 }}>

      {facilities.length > 0 && facilities?.map((floor: any, index: any) => (
        <Box key={index} sx={{ marginBottom: "20px" }}>
          <FacilityAccordion
            floor={floor}
            index={index}
            expanded={expandedFacility}
            onChange={handleChangeFacility}
            handleGetSummaryData={handleGetSummaryData}
          />
        </Box>
      ))}
      {units.length > 0 &&
        <Box sx={{ borderRadius: "10px!important", boxShadow: "none", pt: 2, py: 2 }}>
          <Box
            sx={{
              backgroundColor: "#F6FBFF",
              px: "20px",
              py: "2px",
              borderRadius: "10px",
              "& .MuiAccordionSummary-expandIconWrapper": { marginLeft: "10px" },
              "& .MuiAccordionSummary-content": { margin: 0 },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              gap="30px"
              sx={{ width: "100%", justifyContent: "space-between", my: "10px" }}
            >
              <Box display="flex" alignItems="center" gap="30px">
                <Box
                  display="flex"
                  alignItems="center"
                  gap="10px"
                  justifyContent="space-between"
                >
                  <Box display="flex" alignItems="center" gap="10px">
                    <Box sx={{ lineHeight: 0 }}>
                      <LabelIcons type="L" isUnit={true} />
                    </Box>
                    <Box>
                      Unit
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      }
      {units.length > 0 && units?.map((floor: any, index: any) => (
        <Box key={index} sx={{ marginBottom: "20px" }}>
          <FacilityAccordion
            floor={floor}
            index={index}
            expanded={expandedUnit}
            onChange={handleChangeUnit}
            handleGetSummaryData={handleGetSummaryData}
          />
        </Box>
      ))}
    </Box>
  );
};

export default Dashboard;
